import { GambleSendCommand } from "slotworks/commands/comms/gamble-spin-command";
import GameState from "slotworks/model/game-state";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";

class GambleSend extends State {
    public onEnter(): void {
        super.onEnter();
        SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, true);
        GambleSendCommand().then(() => {
            SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, false);
            GameState.getCurrentGame().nextRecord();
            this.complete();
        });
    }
}

export default GambleSend;
